<template>
  <div :class="$options.name" :style="{ left: dimen(left), top: dimen(topValue), right: dimen(right), bottom: dimen(bottom) }">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { dimen } from 'tg-map-core'
import { defineComponent } from 'vue'
/** TgMap上的Widget, 只是对绝对布局进行简单的封装 */
export default defineComponent({
  name: 'tg-map-widget',
  props: {
    left: {
      type: [Number, String],
      default: null,
    },
    top: {
      type: [Number, String],
      default: null,
    },
    right: {
      type: [Number, String],
      default: null,
    },
    bottom: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    topValue() {
      // 防止默认看不到组件
      return this.top == null && this.bottom == null ? 0 : this.top
    },
  },
  methods: {
    dimen,
  },
})
</script>
<style lang="scss">
.tg-map-widget {
  position: absolute;
}
</style>
